import Router from 'next/router';

import * as TYPES from './types';
import tmdbAPI from 'services/tmdbAPI';
import LINKS from 'utils/constants/links';
import { TMDB_API_VERSION } from 'config/tmdb';

// https://api.themoviedb.org/3/movie/550/watch/providers?api_key=4d2eb103d98235da04282f551f415340&language=en-US
// /movie/{movie_id}/release_dates
const getStreaming = movieId => async dispatch => {
  try {
    const response = await tmdbAPI.get(`/${TMDB_API_VERSION}/movie/${movieId}/watch/providers`);
    dispatch({
      type: TYPES.FETCH_STREAMING,
      payload: response.data.results
    });
  } catch (error) {
    console.log('[getStreaming] error => ', error);
    dispatch({type: TYPES.INSERT_ERROR, payload: error.response});
    Router.push(LINKS.ERROR.HREF);
  }
};

export default getStreaming;
